var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4A54A3;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.8,13.9c0.2,0,0.3,0,0.5,0c1.1,0,2-0.7,2.2-1.8c0.3-1.5,0.8-2.7,1.6-3.6c1.3-1.6,3.5-2.3,5.1-2.7 c0,0.8-0.2,1.7-0.4,2.6c-0.3,1.2,0.4,2.5,1.6,2.8c0.2,0.1,0.4,0.1,0.6,0.1c1,0,1.9-0.7,2.2-1.7c0.9-3.4,0.5-6.5,0.5-6.7 c-0.2-1.1-1.1-2-2.3-2c-0.3,0-7,0.2-10.7,4.6c0,0,0,0,0,0C31.3,7.1,30.5,9,30,11.3C29.7,12.5,30.5,13.7,31.8,13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.9,43.1c-3.5-1.1-5.8-4.3-5.8-8c0-3.2,1.9-6.2,4.8-7.6c0.6-0.3,1-0.8,1.2-1.4c0.2-0.6,0.1-1.3-0.3-1.9 c-3.1-4.7-8.2-7.5-13.7-7.5c-2.6,0-5.5,1-8.4,2.8c-2.8-1.8-5.8-2.8-8.4-2.8c-8.4,0-16.9,6.6-16.9,19.2c0,11.9,7.9,27,16.9,27 c2.6,0,5.5-1,8.4-2.8c2.8,1.8,5.8,2.8,8.4,2.8c6.9,0,12.8-8.8,15.3-17C56.7,44.8,56.1,43.5,54.9,43.1z M41.1,58.4c-2,0-4.5-1-7-2.9 c-0.4-0.3-0.9-0.4-1.4-0.4c-0.5,0-1,0.1-1.4,0.4c-2.4,1.8-5,2.9-7,2.9c-5.1,0-12.3-11.6-12.3-22.5c0-10,6.4-14.6,12.3-14.6 c2,0,4.5,1,7,2.9c0.8,0.6,1.9,0.6,2.7,0c2.4-1.8,5-2.9,7-2.9c3.2,0,6.2,1.3,8.4,3.6c-3.1,2.4-5,6.2-5,10.2c0,4.9,2.7,9.2,6.9,11.4 C48.8,53.3,44.5,58.4,41.1,58.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/apple-logo.f78e578e7453e98fb44fcfcbfd9e42a9.svg";
export { ForwardRef as ReactComponent };